import { render, staticRenderFns } from "./seo.vue?vue&type=template&id=11044a0a&scoped=true"
import script from "./seo.vue?vue&type=script&lang=js"
export * from "./seo.vue?vue&type=script&lang=js"
import style0 from "./seo.vue?vue&type=style&index=0&id=11044a0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11044a0a",
  null
  
)

export default component.exports